import {
  splitArray,
  getPathName,
  changeCurrancyFormat,
  changeDataFormat,
} from "../../../../common/utils/utilsFunc";
import ClayTable from "@clayui/table";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import HeaderTable from "../../../../common/components/HeaderTable";
import React, { useEffect, useState, useContext } from "react";
import arTitles from "../../../../common/services/mock/title.json";
import CgeContextProvider, { CgeContext, ACTIONS } from "../../context/CgeContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE";

import Pagination from "../../../../common/components/Pagination";

function TableServiceStatus({
  title,
  description,
  qtdRowPage,
  textNoResults,
  textFetchError,
  setGlobalAlert,
}) {
  const [activePage, setActivePage] = useState(1);
  const [dataTable, setDataTable] = useState([]);
  const [indexId, setIndexId] = useState(0);
  const [inputSearch, setInputSearch] = useState("");
  const [inputSelected, setInputSelected] = useState("");
  const [loading, setLoading] = useState(false);
  const [rowPage, setRowPageList] = useState(10);
  const [state, dispatch] = useContext(CgeContext);
  const [currentArray, setCurrentArray] = useState([]);
  const [auxArray, setAuxArray] = useState([]);

  let error = null;

  const data = state.idList ? state.idList : [];
  let newArrTitle = arTitles[getPathName()]?.map((item) => item.label);

  function setRowPage(nPage) {
    setActivePage(1);
    setRowPageList(Number(nPage));
  }

  if (error && loading) {
    setLoading(false);
  }

  useEffect(() => {
    newArrTitle = arTitles[getPathName()]?.map((item) => item.label);
  }, [getPathName()]);

  useEffect(() => {
    if (state.idList.length > 0) {
      if (data.length > 0) {
        dispatch({
          payload: data,
          type: ACTIONS.SET_IDCLIENT,
        });
        setIndexId(indexId + 1);
      }
    }
  }, [state.idList]);

  useEffect(() => {
    const objCb = state.currentBalance;

    setLoading(false);
    if (objCb) {
      if (objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.RETURN === 0) {
        setDataTable([...dataTable, ...objCb.ConsultarListaEstadoServiciosResponse?.ITEM]);
      } else if (state.currentBalance.status) {
        setGlobalAlert(textFetchError, "warning", true, "Advertencia");
      } else {
        setGlobalAlert(
          objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.TEXTO_RETURN,
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.currentBalance]);

  const propsTable = {
    title: title,
    description: description,
    setActivePage: setActivePage,
    qtdRowPage: qtdRowPage,
    setRowPage: setRowPage,
    rowPage: rowPage,
    activePage: activePage,
    auxArray: auxArray,
    arTitles: arTitles,
    excelBtn: true,
    showPagination: false,
  };

  var panelFooter = (
    <>
      <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
        <Pagination
          items={auxArray}
          onChangePage={setActivePage}
          qtdRowPage={qtdRowPage}
          setRowPage={setRowPage}
          pageSize={rowPage}
          currentPg={activePage}
        />
      </div>
    </>
  );

  React.useEffect(() => {
    let arrayOfarrays = [];
    let filterArray = [];
    setAuxArray(dataTable);

    if (inputSearch) {
      filterArray = dataTable.filter(function (obj) {
        return obj.CTA_CTO.toString().includes(inputSearch);
      });
      setAuxArray(filterArray);
      setActivePage(1);
    } else if (inputSelected) {
      filterArray = dataTable.filter(function (obj) {
        return obj.CTA_CTO.toString() === inputSelected;
      });
      setAuxArray(filterArray);
      setActivePage(1);
    }

    if (!inputSelected && !inputSearch) {
      arrayOfarrays = splitArray(dataTable, rowPage);
      setCurrentArray(arrayOfarrays[activePage - 1]?.sort((a, b) => a.CTA_CTO - b.CTA_CTO));
    } else if (dataTable?.length === 0) {
      setGlobalAlert(textFetchError, "warning", true, "Advertencia");
      setLoading(false);
    } else {
      arrayOfarrays = splitArray(filterArray, rowPage);
      setCurrentArray(arrayOfarrays[activePage - 1]?.sort((a, b) => a.CTA_CTO - b.CTA_CTO));
    }
  }, [inputSearch, inputSelected, dataTable, activePage]);

  React.useEffect(() => {
    if (state.errorFetch) {
      setLoading(false);
    }
  }, [state.errorFetch]);

  useEffect(() => {
    setLoading(true);

    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  return (
    <>
      <HeaderSearch
        data={data}
        setSearch={setInputSearch}
        setSelected={setInputSelected}
        idClient={inputSelected}
        inputSearch={inputSearch}
      />
      <div>
        <CGE.Panel footerContent={panelFooter}>
          <HeaderTable props={propsTable} />
          <ClayTable
            class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
            id="table-to-xls"
          >
            <ClayTable.Head>
              <ClayTable.Row>
                {newArrTitle?.map((title) => {
                  return (
                    <ClayTable.Cell headingCell className="clientCell font-weight-bold">
                      {title}
                    </ClayTable.Cell>
                  );
                })}
              </ClayTable.Row>
            </ClayTable.Head>
            <ClayTable.Body>
              {currentArray ? (
                currentArray?.map((obj) => {
                  return (
                    <ClayTable.Row className="tableRow">
                      {Object.keys(obj).map((index) => {
                        return (
                          <ClayTable.Cell
                            className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                            title={obj[index].length > 23 ? obj[index] : ""}
                          >
                            {index === "ESTADO_PAGO" && obj[index] === "IMPAGO" ? (
                              <a
                                href={`detalle-de-cuenta-priv?ctacto=${obj["CTA_CTO"]}`}
                                className="text-decoration-none "
                              >
                                ¡PAGAR AQUÍ!
                              </a>
                            ) : index === "TOTAL_PAGAR" ? (
                              changeCurrancyFormat(Number(obj[index]), true)
                            ) : (
                              obj[index]
                            )}
                          </ClayTable.Cell>
                        );
                      })}
                    </ClayTable.Row>
                  );
                })
              ) : (
                <ClayTable.Row>
                  <ClayTable.Cell
                    colspan={newArrTitle?.length}
                    className="text-no-results  font-weight-bold"
                  >
                    {!loading && textNoResults}
                  </ClayTable.Cell>
                </ClayTable.Row>
              )}
            </ClayTable.Body>
          </ClayTable>
          {loading && <Loading />}
        </CGE.Panel>
      </div>
    </>
  );
}

const TableServiceStatusWithProvider = ({
  title,
  description,
  qtdRowPage,
  textNoResults,
  textFetchError,
  setGlobalAlert,
}) => (
  <CgeContextProvider>
    <TableServiceStatus
      title={title}
      description={description}
      qtdRowPage={qtdRowPage}
      textNoResults={textNoResults}
      textFetchError={textFetchError}
      setGlobalAlert={setGlobalAlert}
    />
  </CgeContextProvider>
);
export default TableServiceStatusWithProvider;
